import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { Button, Skeleton } from '@dashboard/ui'
import { BackButton, ButtonIcon, Floating, PageHeader } from '@/ui'
import { Copy03, DotsHorizontal } from '@/icons'
import { GAME_WEBHOOKS_PATH } from '@/libs/routerPaths'
import { WebhookRedacted } from '@/api/dashboard'
import { WebhookMoreMenu } from './WebhookMoreMenu'
import { useCurrentUser } from '@/api/useCurrentUser'
import { WebhookDetails } from '../icons'

interface WebhookTitleBarProps {
  webhook: WebhookRedacted
}

export const WebhookTitleBar = ({ webhook }: WebhookTitleBarProps) => {
  const { isDeveloper } = useCurrentUser()
  const { companyId, gameId } = useParams() as { companyId: string; gameId: string; pluginSlug: string }
  const navigate = useNavigate()
  return (
    <>
      <PageHeader
        extra={
          <>
            <Button onClick={() => navigator.clipboard.writeText(webhook.id + '')} color="secondary" variant="outline">
              {webhook.id}
              <Copy03 />
            </Button>
            {isDeveloper && (
              <Floating menu={<WebhookMoreMenu webhook={webhook} />} placement="bottom-end">
                <ButtonIcon variant="outline" color="secondary" size="sm">
                  <DotsHorizontal />
                </ButtonIcon>
              </Floating>
            )}
          </>
        }
      >
        <BackButton
          icon={<WebhookDetails size={34} />}
          text={webhook.url}
          onClick={() =>
            navigate(
              generatePath(GAME_WEBHOOKS_PATH, {
                companyId: companyId,
                gameId: gameId,
              }),
            )
          }
        />
      </PageHeader>
    </>
  )
}

export const WebhookTitleBarSkeleton = () => (
  <div className="mb-8 mt-3 flex gap-3">
    <Skeleton className="size-8" />
    <div>
      <Skeleton className="mb-0.5 h-2.5 w-24" />
      <Skeleton className="h-[22px] w-64" />
    </div>
  </div>
)
